import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import Session from '../utils/session.service';
import Time from '../utils/timer.service';

@Injectable({ providedIn: 'root' })
export default class StatusService {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private time: Time = inject(Time);
	
	store: any = {
		user: {},
		users: {},
		interval: 120000,
	};
	
	addUsers(users) {
		if (!users || !users.length) return;
		var ids: any = Object.keys(this.store.users);
		var newUsers: any = users.filter(function(newUser) { return !ids.filter(function(id) { return id === newUser.id; }).length; });
		if (!newUsers.length) return;
		console.log('STATUS', 'adding ' + newUsers.length + ' new users');
		
		newUsers.forEach((user) => { this.store.users[user.id] = user; });
		this.initPolling(true);
	}
	
	removeUsers(users) {
		if (!users || !users.length) return;
		
		users.forEach((user) => { delete this.store.users[user.id]; });
	}
	
	initPolling(restart) {
		if (restart) this.destroyPolling();
		console.log('STATUS', 'initialize polling');
		
		this.store.user = this.session.getSession().user || {};
		if (this.time.getTimer(this.config.getTimerConfig().Chat.STATUS)) return;
		this.updateStatuses();
		this.time.newTimer(this.config.getTimerConfig().Chat.STATUS, () => { this.updateStatuses(); }, this.store.interval);
	}
	
	destroyPolling() {
		if (this.time.getTimer(this.config.getTimerConfig().Chat.STATUS)) console.log('STATUS', 'destroy polling');
		this.time.deleteTimer(this.config.getTimerConfig().Chat.STATUS);
	}
	
	updateStatuses() {
		if (!this.store.user || !this.store.user.phoneNumber || !Object.keys(this.store.users).length) return;
		console.log('STATUS', 'updating statuses');
		
		var userIds: any = Object.keys(this.store.users);
		var url: any = this.config.getSignalApi() + '/rest/user/' + this.store.user.phoneNumber + '/status/list?userIds=' + userIds.join(',');
		
		this.httpClient.get(url).toPromise()
		.then((response) => {
			if (response) {
				var statuses: any = response;
				statuses.forEach((status) => {
					if (this.store.users[status.remoteId]) this.store.users[status.remoteId].status = status.status;
				});
			}
		});
	}
	
	getStatuses() {
		return this.store.users;
	}
	
	setStatus(user, status) {
		console.log('STATUS', 'set status to "' + status + '" for user id ' + user);
		if (!user) return;
		if (this.store.users[user]) this.store.users[user].status = status;
		this.store.users[user] = { id: user, status: status };
	}
	
}